import React from 'react';
import { ArrowRightIcon, InfinityIcon } from 'lucide-react';
import { offers, Offer } from '../data/product';
import { scrollToPackCta } from '../utils/offerBus';
interface FinalCtaProps {
  onSelectOffer: (id: Offer['id']) => void;
}
const buttonLabels: Record<Offer['id'], string> = {
  single: 'Get the X1 for $49.95',
  trio: 'Get 3 X1 Systems for $99.90',
  crew: 'Get 6 X1 Systems for $179.90'
};
export function FinalCta({
  onSelectOffer
}: FinalCtaProps) {
  return <section aria-labelledby="final-heading" className="border-b border-white/10 bg-ink-950" data-id="element-524" data-mp="1ee1ulz7fhnts">
      <div className="mx-auto max-w-[1400px] px-4 py-16 text-center sm:px-6 lg:px-8 lg:py-24" data-id="element-525" data-mp="1t2ydysexqn9p">
        <h2 id="final-heading" className="grit-headline mx-auto max-w-4xl text-[clamp(2.5rem,9vw,5.5rem)] font-extrabold uppercase text-offwhite" data-id="element-526" data-mp="1t4r9pco0fn2x">
          Stop holding the light.
          <br data-id="element-527" data-mp="1x4jjfsp53z9v" />
          <span className="text-grit-500" data-id="element-528" data-mp="1x51p1fxozpug">Start wearing it.</span>
        </h2>

        <div className="mx-auto mt-6 max-w-md space-y-1 text-lg font-medium text-steel-300" data-id="element-529" data-mp="n5m887qsge4i">
          <p data-id="element-530" data-mp="s4pc3ov18eaw">Three lenses.</p>
          <p data-id="element-531" data-mp="s3w2mg4ovap2">Built-in illumination.</p>
          <p data-id="element-532" data-mp="s4xqxmapttoq">Both hands free.</p>
        </div>

        <p className="mx-auto mt-6 inline-flex items-center gap-2 border-2 gold-edge bg-[#1a1408] px-5 py-3" data-id="element-533" data-mp="x38zzut6s05w">
          <InfinityIcon className="h-6 w-6 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-534" data-mp="12353zu1vvrlg" />
          <span className="grit-headline text-2xl font-extrabold uppercase gold-text sm:text-3xl" data-id="element-535" data-mp="16503qu461wx4">
            Lifetime replacement on multi-packs
          </span>
        </p>

        <p className="mt-8 font-display text-3xl font-extrabold uppercase leading-none text-offwhite" data-id="element-536" data-mp="1b173u69vse75">
          GritVue X1™
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-537" data-mp="1ktmjgwxpgqov">Light where you look.</p>

        <div className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-3" data-id="element-538" data-mp="1ptr0co2iznfm">
          {offers.map(offer => <a key={offer.id} href="#offer" onClick={event => {
          event.preventDefault();
          onSelectOffer(offer.id);
          scrollToPackCta(offer.id);
        }} className={`group flex items-center justify-center gap-2 px-5 py-4 font-display text-xl font-extrabold uppercase tracking-wide transition-[background-color,color,transform] duration-150 ease-grit active:translate-y-[2px] ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'border-2 border-white/25 text-offwhite hover:border-grit-500 hover:text-grit-500'}`} data-id="element-539" data-mp="1tukmbbweqs5v">
              {buttonLabels[offer.id]}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-540" data-mp="iec8vrsuka7i" />
            </a>)}
        </div>

        <p className="mt-10 font-display text-2xl font-extrabold uppercase tracking-[0.1em] text-offwhite" data-id="element-541" data-mp="2k7jxjruco462">
          GritVue
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-542" data-mp="2a4o1pu5k6nlv">See the job through.</p>
      </div>
    </section>;
}